<template lang="pug">

  campaigns-layout.comm-layout
    share-folder-modal(
      ref="shareModal"
      :teamMembers="teamMembersList"
      @share-folder="shareFolder"
    )
    v-dialog(v-model="openFolderModal" persistent max-width="480")
      v-card
        title-bar(dark) {{ isNewFolder ? "New Folder" : "Edit Folder" }}
        v-card-text
          v-text-field(
            v-model="modalFolderName"
            label="Folder Name"
            :error-messages="modalFolderErrorMessage"
          )
          v-textarea(
            v-model="modalFolderDescription"
            auto-grow
            rows="1"
            label="Description"
          )
        v-card-actions
          v-spacer
          v-btn(flat @click="handleClickCancel") Cancel
          v-btn.primary(
            :disabled="!modalFolderName.trim().length"
            @click="handleSubmitTemplateFolderModal"
          ) {{ isNewFolder ? "OK" : "Update" }}
    v-snackbar(:value="!!templatesErrorMessage" color="error")
      div {{ templatesErrorMessage }}
    v-snackbar(:value="!!templatesSuccessMessage" color="success")
      div {{ templatesSuccessMessage }}
    v-snackbar(v-model="showFolderSharingSuccess" color="success")
      div The Folder and its templates were shared successfully
    v-snackbar(v-model="showFolderSharingError" color="error")
      div {{ sharingFolderErrorMessage }}
    v-container(fluid grid-list-lg)
      v-flex.py-0(xs12)
        v-flex(x12)
          a.trailback(@click="handleGoBack")
            v-icon(small) keyboard_arrow_left
            span Back
        div
          v-flex(xs12 d-flex)
            action-title-bar(title="Templates")
              v-btn.ml-0(
                data-cy="button-new-template"
                color="primary"
                @click="newTemplate()"
              )
                span New Template
              v-btn(
                flat
                color="primary"
                outline
                @click="handleNewFolderAction()")
                span New Folder
              template(slot="extras")
                v-layout(row)
                  v-flex
                    v-menu(
                      offset-y
                      class="align-with-search"
                      v-if="activeTab === TEMPLATES_TAB"
                    )
                      v-toolbar-title.liondesk(dense slot="activator")
                        span.title {{ selectedTemplateTypeName }}
                        v-icon(color="primary" right) arrow_drop_down
                      v-list
                        v-list-tile(
                          v-for="templateType in templateTypesWithAll"
                          @click="filterResultsByTemplateType(templateType.value)" 
                        )
                          v-list-tile-title {{templateType.name}}
                  v-flex
                    v-menu(
                      offset-y
                      class="align-with-search"
                      v-if="activeTab === TEMPLATES_TAB"
                    )
                      v-toolbar-title.liondesk(dense slot="activator")
                        span.title {{ selectedFolderName }}
                        v-icon(color="primary" right) arrow_drop_down
                      v-list
                        v-list-tile(
                          v-for="folder in foldersWithAll"
                          :key="folder.id"
                          @click="filterResultsByFolder(folder.id)"
                        )
                          v-list-tile-title {{folder.name}}
                  v-flex
                    v-text-field(
                      class='campaign-templates-search'
                      solo
                      hide-details
                      single-line
                      prepend-inner-icon='search'
                      :label="searchLabel"
                      @input="searchChanged"
                    )

          v-card.mt-3
            v-tabs(slider-color="primary")
              v-tab(@click="changeActiveTab(TEMPLATES_TAB)")
                span templates
              v-tab(@click="changeActiveTab(FOLDERS_TAB)")
                span folders

              v-tab-item
                v-layout(row)
                  v-flex.pb-0
                    v-data-table.lonewolf-table(
                      ref="templatesTable"
                      data-cy="templates"
                      :headers="headers"
                      :items="templates"
                      item-key="id"
                      :loading="isLoading"
                      hide-actions
                      :total-items="templates.length"
                      :class="{ 'in-progress': isLoading }"
                      @click:remove="handleRemoveResourceModal('delete', 'single', data.item.id)"
                      @click:edit="redirectToShow(data.item.id)"
                    )
                      template(slot="items" slot-scope="props")
                        tr(:id="props.item.id")
                          td.type
                            v-icon {{ templateIconFromType(props.item.template_type) }}
                          td
                            div.row-section.description(
                              @click="handleTemplatePreview(props.item.id)"
                            )
                              strong {{ props.item.description }}

                            div.row-section #[v-icon(small) folder] {{ props.item.template_folder ? props.item.template_folder.name : 'Unknown folder' }}

                            div.row-section(v-if="isEmail(props.item)")
                              em Subject:
                              |  {{ props.item.subject }}
                            div.row-section.text-body(v-else)
                              blockquote {{ getCleanBody(props.item.body) }}

                          td.date
                            date-cell(:data="props.item.created_at")
                          td.date
                            date-cell(:data="props.item.modified_at")
                          td.text-xs-right.actions(data-cy="campaign-action-icons")
                            .single-row
                              v-tooltip(bottom)
                                span Preview Template
                                v-btn(
                                  icon
                                  slot="activator"
                                  @click="handleTemplatePreview(props.item.id)"
                                )
                                  v-icon remove_red_eye
                              v-tooltip(bottom)
                                span Edit Template
                                v-btn(
                                  icon
                                  slot="activator"
                                  @click="handleTemplateEdit(props.item.id)"
                                )
                                  v-icon edit
                              v-tooltip(bottom)
                                span Delete Template
                                v-btn(
                                  icon slot="activator"
                                  @click="handleRemoveResourceModal(props.item)"
                                )
                                  v-icon delete
                    v-layout.pagination
                      v-flex.pages
                        v-pagination(
                          :value="page"
                          :length="templateNumberOfPages"
                          @input="handleTemplateSetPage"
                          :total-visible="7"
                          v-show="templateHasMoreThanOnePage"
                        )
                      v-flex.limits
                        pagination-limit.mr-4(
                          :limits="paginationLimits"
                          :current-limit="limit"
                          @change:limit="templateSetLimit"
                        )
              v-tab-item
                v-layout(row)
                  v-flex.pb-0
                    v-data-table.lonewolf-table(
                      ref="foldersTable"
                      data-cy="folders"
                      :headers="folderTableHeaders"
                      :items="folders"
                      item-key="id"
                      :loading="isLoading"
                      hide-actions
                      :total-items="folders.length"
                      :class="{ 'in-progress': isLoading }"
                    )
                      template(slot="items" slot-scope="props")
                        tr(:id="props.item.id")
                          td
                            span {{ props.item.name }}
                            span(v-if="props.item.original_template_folder_id").shared
                              v-icon(small).folderShared folder_shared
                              div(v-if="!props.item.sharedCount")
                                span Shared by a team member
                            div(v-if="props.item.sharedCount").row-section.shared
                              v-icon(small) share
                              span  Shared with {{ props.item.sharedCount }} team members
                              span(v-if="props.item.original_template_folder_id")  | Shared by a team member
                          td
                            span {{ props.item.description }}
                          td.text-xs-right.actions.single-row(data-cy="folder-action-icons")
                            v-tooltip(bottom)
                              span Show Templates
                              v-btn(
                                icon
                                slot="activator"
                                @click="handleShowTemplateTree(props.item)"
                              )
                                v-icon remove_red_eye
                            v-tooltip(bottom)
                              span Edit Folder
                              v-btn(
                                icon
                                slot="activator"
                                @click="handleFolderEditAction(props.item)"
                              )
                                v-icon edit
                            v-menu(left)
                              v-btn(icon slot="activator" data-cy="contact-communication-actions")
                                v-icon more_vert
                              v-list
                                v-list-tile(@click="openShareModal(props.item)")
                                  span Share With Team Members
                    v-layout.pagination
                      v-flex.pages
                        v-pagination(
                          :value="folderPage"
                          :length="folderNumberOfPages"
                          @input="handleFolderSetPage"
                          :total-visible="7"
                          v-show="folderHasMoreThanOnePage"
                        )
                      v-flex.limits
                        pagination-limit.mr-4(
                          :limits="paginationLimits"
                          :current-limit="foldersLimit"
                          @change:limit="folderSetLimit"
                        )

    template-slide-drawer(
      :value="templateToEdit"
      @change="savedTemplate"
      @deleteTemplate="handleRemoveResourceModal"
    )

    template-tree-slide-drawer(
       ref="templateTreeSlideDrawer"
      :show="showDrawerTemplatesTree"
      @change="savedTemplate"
    )

    remove-resource-modal(
      v-model="showDeleteTemplateDialogCopy"
      action="delete"
      resource-singular="template"
      resource-plural="templates"
      remove-amount="single"
      :single-amount-message="deleteConfirmationMessage"
      @close="onRemoveResourceModalClose")
</template>

<script>
import {
  mapActions,
  mapState,
  mapGetters,
  mapMutations,
} from 'vuex';
import { debounce } from '@/Core/utilities';
import CampaignsLayout from '@/Campaigns/Layout';
import DateCell from '@/Contacts/components/DateCell';
import Pagination from '@/Core/mixins/pagination';
import { templateIconFromType } from '@/Campaigns/config/actions';
import { COMMUNICATION_TYPE } from '@/Core/config/communicationType';
import GoBackNavigation from '@/Contacts/mixins/goBackNavigation';
import TemplateEditor from '@/Campaigns/components/TemplateEditor';
import ActionTitleBar from '@/Core/components/ActionTitleBar';
import PaginationLimit from '@/Core/components/PaginationLimit';
import RemoveResourceModal from '@/Tasks/components/RemoveResourceModal';
import toggleSlideDrawer from '@/Core/mixins/toggle-slide-drawer';
import SlideDrawer from '@/Core/components/SlideDrawer';
import TemplatePicker from '@/Campaigns/components/TemplatePicker';
import TemplateSlideDrawer from '@/Campaigns/components/TemplateSlideDrawer';
import TemplateTreeSlideDrawer from '@/Campaigns/components/TemplateTreeSlideDrawer';
import TitleBar from '@/Core/components/TitleBar';
import extractTextFromHtml from '@/Text/utilities/extractTextFromHtml';
import ShareFolderModal from '@/Campaigns/components/ShareFolderModal';
import { FOLDERS_TAB, TEMPLATES_TAB } from '../config/constants';

export default {
  components: {
    ActionTitleBar,
    CampaignsLayout,
    DateCell,
    PaginationLimit,
    RemoveResourceModal,
    SlideDrawer,
    TemplateEditor,
    TemplatePicker,
    TemplateSlideDrawer,
    TitleBar,
    TemplateTreeSlideDrawer,
    ShareFolderModal
  },
  mixins: [
    Pagination,
    GoBackNavigation,
    toggleSlideDrawer,
  ],
  created() {
    this.templateSetSortField('created_at');
    this.folderSetSortField('created_at');
  },
  mounted() {
    // reset filters on page load
    this.resetSearch();
    this.findTemplates();
    this.getAllTemplateFolders();
  },
  data() {
    return {
      FOLDERS_TAB: FOLDERS_TAB,
      TEMPLATES_TAB: TEMPLATES_TAB,
      openFolderModal: false,
      modalFolderName: '',
      modalFolderDescription: '',
      modalFolderErrorMessage: '',
      isNewFolder: false,
      templateToShowTemplates: {},
      communicationTypes: COMMUNICATION_TYPE,
      selectedFolderId: 0,
      removeCampaignName: '',
      actions: [],
      headers: [
        {
          text: 'Type',
          value: 'type',
          sortable: false,
        },
        {
          text: 'Template',
          value: 'template',
          sortable: false,
        },
        {
          text: 'Created',
          value: 'created_at',
          sortable: false,
        },
        {
          text: 'Modified',
          value: 'modified_at',
          sortable: false,
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
        },
      ],
      folderTableHeaders: [
         {
           text: 'Folder Name',
           value: 'name',
           sortable: false,
         },
         {
           text: 'Description',
           value: 'description',
           sortable: false,
         },
         {
          text: '',
          value: 'actions',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      teamMembersList: state => state.teamMembers.teamMembers,
      sharingFolderErrorMessage: state => state.templates.sharingFolderErrorMessage,
      sharingFolderError: state => state.templates.sharingFolderError,
      sharingFolderSuccess: state => state.templates.sharingFolderSuccess,
      activeTab: state => state.templates.activeTab,
      templatesSuccessMessage: state => state.templates.templatesSuccessMessage,
      templatesErrorMessage: state => state.templates.templatesErrorMessage,
      isLoading: state => state.templates.templatesInProgress,
      isEditing: state => state.templates.isEditing,
      templates: state => state.templates.templates,
      folders: state => state.templates.folders,
      foldersFilters: state => state.templates.foldersFilters,
      templateTypes: state => state.templates.templateTypes,
      page: state => state.templates.pagination.page,
      limit: state => state.templates.pagination.limit,
      total: state => state.templates.pagination.total,
      sortField: state => state.templates.pagination.sortField,
      sortDirection: state => state.templates.pagination.sortDirection,
      folderPage: state => state.templates.foldersPagination.page,
      foldersLimit: state => state.templates.foldersPagination.limit,
      foldersTotal: state => state.templates.foldersPagination.total,
      templateToEdit: state => state.templates.templateToEdit,
      showDrawerTemplatesTree: state => state.templates.showDrawerTemplatesTree,
      showDeleteTemplateDialog: state => state.templates.showDeleteTemplateDialog,
      templateToRemove: state => state.templates.templateToRemove,
      templateToTreeTemplates: state => state.templates.templateToTreeTemplates,
    }),

    ...mapGetters('teamMembers', ['teamMembersInfo']),
    ...mapGetters('templates', [
      'selectedFolderName',
    ]),
    ...mapGetters('templates', [
      'selectedTemplateTypeName',
    ]),
    ...mapGetters({
      templateHasMoreThanOnePage: 'templates/pagination/hasMoreThanOnePage' ,
      templateNumberOfPages: 'templates/pagination/numberOfPages',
      templateIsOnLastPages: 'templates/pagination/isOnLastPage',
      folderHasMoreThanOnePage: 'templates/foldersPagination/hasMoreThanOnePage',
      folderNumberOfPages: 'templates/foldersPagination/numberOfPages',
      folderIsOnLastPages: 'templates/foldersPagination/isOnLastPage',
    }),

    deleteConfirmationMessage() {
      if (!this.templateToRemove) {
        return null;
      }

      return `Are you sure you want to delete the template "${this.templateToRemove.description}"?`;
    },

    foldersWithAll() {
      return [
        { id: null, name: 'All folders' },
        ...this.foldersFilters,
      ];
    },
    templateTypesWithAll() {
      return [
        { name: 'All types', value: null },
        ...this.templateTypes,
      ];
    },
    searchLabel() {
      return this.activeTab === TEMPLATES_TAB ? 'Search by Email Subject or Description' : 'Search by Name or Description';
    },
    showDeleteTemplateDialogCopy: {
      get() {        
        return this.showDeleteTemplateDialog;
      },
      set(value) {
        this.setShowDeleteTemplateDialog(value);
      },
    },
    showFolderSharingSuccess: {
      get() {
        return this.sharingFolderSuccess;
      },
      set(val) {
        this.setSharingFolderSuccess(val);
      },
    },
    showFolderSharingError: {
      get() {
        return this.sharingFolderError;
      },
      set(val) {
        this.setSharingFolderError(val);
      },
    }
  },
  methods: {
    savedTemplate(template) {
      this.findTemplates();
    },

    isEmail(template) {
      return template.template_type.toLowerCase() === this.communicationTypes.EMAIL.toLowerCase();
    },

    onRemoveResourceModalClose(isRemovingResource) {
      this.setShowDeleteTemplateDialog(false);
      if (isRemovingResource) {
        this.removeTemplate(this.templateToRemove.id).then(() => {
          this.setShowDrawerEdit(false);
          this.$refs.templateTreeSlideDrawer.fetchTemplates(this.templateToTreeTemplates);
        });
        
      }
    },

    handleRemoveResourceModal(template) {
      this.setShowDeleteTemplateDialog(true);
      this.setTemplateToRemove(template);
    },

    // TODO CS / TODO MM - add individual query parameters
    filterResultsByTemplateType(templateType) {
      this.addQuery({ template_type: templateType });
    },

    searchChanged(searchValue) {
      debounce(this.addQuery, [{ searchValue }]);
    },

    filterResultsByFolder(templateFolderId) {
      this.selectedFolderId = templateFolderId;
      this.addQuery({ template_folder_id: templateFolderId });
    },

    handleTemplatePreview(templateId) {
      this.setTemplateToEdit(this.templates.find(template => template.id === templateId));
      this.setShowDrawerEdit(true);
      this.setEditing(false);
    },

    handleTemplateEdit(templateId) {
      this.handleTemplatePreview(templateId);
      this.setShowDrawerEdit(true);
      this.setEditing(true);
    },

    newTemplate(template = null) {
      this.setTemplateToEdit({});
      this.setShowDrawerEdit(true);
    },

    handleFolderEditAction(folder) {
      this.modalFolderId = folder.id;
      this.modalFolderName = folder.name;
      this.modalFolderDescription = folder.description;
      this.openFolderModal = true;
      this.isNewFolder = false;
    },
    openShareModal(folder) {
      this.$refs.shareModal.open_modal(folder);
    },

    handleShowTemplateTree(folder) {
      this.resetTemplateToTreeTemplates();
      this.setTemplateToTreeTemplates(folder);
      this.setShowDrawerTemplatesTree(true);
    },

    handleNewFolderAction() {
      this.openFolderModal = true;
      this.isNewFolder = true;
    },
    ...mapActions('teamMembers', ['findTeamMembers']),
    ...mapMutations('templates', [
      'setTemplateToEdit',
      'setShowDrawerTemplatesTree',
      'setShowDrawerEdit',
      'setShowDeleteTemplateDialog',
      'setTemplateToRemove',
      'setTemplateToTreeTemplates',
      'setSharingFolderError',
      'setSharingFolderSuccess',
    ]),
    ...mapActions('templates', [
      'addQuery',
      'findTemplates',
      'findTemplateFolders',
      'getAllTemplateFolders',
      'removeTemplate',
      'setEditing',
      'setFolder',
      'createTemplateFolder',
      'updateTemplateFolder',
      'setActiveTab',
      'resetTemplateToTreeTemplates',
      'shareFolderWithTeamMembers',
      'resetSearch',
    ]),
    ...mapActions({
      templateSetLimit: 'templates/pagination/setLimit',
      templateSetPage: 'templates/pagination/setPage',
      templateSetSortField: 'templates/pagination/setSortField',
      folderSetLimit: 'templates/foldersPagination/setLimit',
      folderSetPage: 'templates/foldersPagination/setPage',
      folderSetSortField: 'templates/foldersPagination/setSortField',
    }),
    ...mapActions('templates/pagination', [
      'setLimit',
      'setPage',
      'setSortField',
    ]),
    
    templateIconFromType,

    async handleSubmitTemplateFolderModal() {
      let error = "";
      
      if(this.isNewFolder) {
        error = await this.createTemplateFolder({
          name: this.modalFolderName,
          description: this.modalFolderDescription,
        });
      } else {
          error = await this.updateTemplateFolder({
            id: this.modalFolderId,
            name: this.modalFolderName,
            description: this.modalFolderDescription,
        });
      }
      
      if (error) {
        this.modalFolderErrorMessage = error.message;
      } else {
        this.clearModalFolderData()
        await this.findTemplateFolders(); // with pagination
        await this.getAllTemplateFolders();
        this.openFolderModal = false;
      }
    },

    handleClickCancel() {
      this.openFolderModal = false;
      this.clearModalFolderData()  
    },

    clearModalFolderData() {
      this.modalFolderId = 0;
      this.modalFolderName = '';
      this.modalFolderDescription = '';
      this.modalFolderErrorMessage = '';
    },
    getCleanBody(text) {
      return extractTextFromHtml(text);
    },
    async changeActiveTab(activeTab) {
      await this.setActiveTab(activeTab);
      if (activeTab === FOLDERS_TAB && !this.teamMembersInfo.length) {
        await this.findTeamMembers();
      }
    },
    async shareFolder(folderId, teamMembersIds){
      await this.shareFolderWithTeamMembers({
        folderId: folderId,
         teamMembersIds: teamMembersIds
      });
      this.findTemplateFolders();
    },
    handleTemplateSetPage(event) {
      this.pagination_scrollToTop(this.$refs.templatesTable);
      this.templateSetPage(event);
    },
    handleFolderSetPage(event) {
      this.pagination_scrollToTop(this.$refs.foldersTable);
      this.folderSetPage(event);
    },
  },
};
</script>

<style lang="scss" scoped>
.align-with-search {
  margin-top: 6px;
}


table {

  .description {
    cursor: pointer;
  }

  .text-body {
    margin-top: 4px;
    blockquote {
      border-left: 2px solid #eee;
      padding-left: 5px;
      margin-left: 2px;
    }
  }

  td.type {
    width: 80px;
  }

  td.date {
    width: 140px;
  }
}

.shared {
  color: var(--v-secondary-lighten3);
  font-size: 12px;
}
.folderShared {
  padding-left: 5px;
}
</style>
